import * as moment from "moment";

export interface ICachingTimesService {
    getTeamCacheTimeout(): any;
    getUserCacheTimeout(): any;
    getCleanUpInterval(): number;
}

export class CachingTimesProvider {
    public team = 5;
    public user = 5;
    public cleanUp = 1000 * 60 * 10; // 10min

    public $get():ICachingTimesService {
        return {
            getTeamCacheTimeout: () => {
                return moment.utc().add(this.team, "minutes");
            },
            getUserCacheTimeout: () => {
                return moment.utc().add(this.user, "minutes");
            },
            getCleanUpInterval: () => {
                return this.cleanUp;
            }
        };
    };

    public static instance() {
        return new CachingTimesProvider();
    }
}